// extracted by mini-css-extract-plugin
export default {"carouselContainer":"carousel_carouselContainer__3T80B","carouselItens":"carousel_carouselItens__dMcJy","scroll":"carousel_scroll__AkamQ"};